import { useEffect } from "react";
import { Mail, Phone } from "lucide-react";

const Cookies = () => {
  useEffect(() => {
    document.title = "Çerez Politikası | Reklam Uzmanı";
    
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', 'Reklam Uzmanı Çerez Politikası. Web sitemizde kullanılan çerezler ve kişiselleştirme hakkında bilgi.');
    }
    
    const metaRobots = document.createElement('meta');
    metaRobots.name = 'robots';
    metaRobots.content = 'noindex, nofollow';
    document.head.appendChild(metaRobots);
    
    window.scrollTo(0, 0);
    
    return () => {
      document.head.removeChild(metaRobots);
    };
  }, []);

  return (
    <div className="bg-white min-h-screen pt-20">
      {/* Header */}
      <div className="bg-gradient-to-r from-[#012f23] to-[#059669] text-white py-16">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <h1 className="text-3xl md:text-4xl font-bold mb-4">
            Çerez Politikası
          </h1>
          <p className="text-gray-200 text-lg">
            Web sitemizde kullanılan çerezler hakkında detaylı bilgi
          </p>
          <p className="text-gray-200 mt-2">
            Son Güncelleme: 16 Ekim 2025
          </p>
        </div>
      </div>

      {/* Content */}
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="prose prose-lg max-w-none">
          
          <div className="bg-blue-50 border-l-4 border-blue-500 p-6 mb-10">
            <p className="text-gray-800 leading-relaxed">
              Reklam Uzmanı olarak, web sitemizin daha verimli çalışmasını sağlamak, kullanıcı deneyimini kişiselleştirmek ve pazarlama faaliyetlerini yürütmek amacıyla çerezler kullanmaktayız. Bu politika, hangi çerezleri kullandığımızı, ne amaçla kullandığımızı ve çerezleri nasıl yönetebileceğinizi açıklar.
            </p>
          </div>

          <section className="mb-10">
            <h2 className="text-2xl font-bold text-gray-900 mb-4">
              1. Çerez Nedir?
            </h2>
            <div className="text-gray-700 leading-relaxed">
              <p className="mb-4">
                Çerezler (cookies), bir web sitesini ziyaret ettiğinizde cihazınıza (bilgisayar, tablet, akıllı telefon) kaydedilen küçük metin dosyalarıdır. Çerezler, web sitelerinin daha verimli çalışmasını sağlar ve site sahiplerine bilgi sağlar.
              </p>
              <p className="mb-4">
                Çerezler genellikle kullanıcı deneyimini geliştirmek, sitenin performansını ölçmek, kullanıcı tercihlerini hatırlamak ve kişiselleştirilmiş içerik sunmak için kullanılır.
              </p>
            </div>
          </section>

          <section className="mb-10">
            <h2 className="text-2xl font-bold text-gray-900 mb-4">
              2. Kullandığımız Çerez Türleri
            </h2>
            <div className="text-gray-700 leading-relaxed">
              
              <div className="space-y-6">
                <div className="border-l-4 border-green-500 pl-6">
                  <h3 className="text-xl font-semibold text-gray-800 mb-3">
                    2.1. Zorunlu Çerezler (Strictly Necessary Cookies)
                  </h3>
                  <p className="mb-3">
                    Bu çerezler, web sitesinin temel işlevlerini yerine getirmesi için gereklidir ve devre dışı bırakılamaz. Genellikle yalnızca hizmet talebinde bulunmanıza (gizlilik tercihlerinizi belirleme, oturum açma, formları doldurma gibi) yanıt olarak ayarlanırlar.
                  </p>
                  <p className="text-sm font-semibold text-gray-800">Kullanım Amaçları:</p>
                  <ul className="list-disc list-inside space-y-1 ml-4 text-sm">
                    <li>Güvenlik ve oturum yönetimi</li>
                    <li>CSRF (Cross-Site Request Forgery) koruması</li>
                    <li>Çerez tercih ayarlarınızın saklanması</li>
                    <li>Temel site navigasyonu</li>
                  </ul>
                </div>

                <div className="border-l-4 border-blue-500 pl-6">
                  <h3 className="text-xl font-semibold text-gray-800 mb-3">
                    2.2. Performans Çerezleri (Analytics Cookies)
                  </h3>
                  <p className="mb-3">
                    Bu çerezler, web sitemizin nasıl kullanıldığını anlamamıza yardımcı olur. Ziyaretçi sayısı, en çok ziyaret edilen sayfalar, kullanıcıların sitede geçirdiği süre gibi istatistiksel bilgileri anonim olarak toplar.
                  </p>
                  <p className="text-sm font-semibold text-gray-800">Kullanım Amaçları:</p>
                  <ul className="list-disc list-inside space-y-1 ml-4 text-sm">
                    <li>Google Analytics 4 (GA4) ile trafik analizi</li>
                    <li>Sayfa görüntüleme sayıları ve oturum süreleri</li>
                    <li>Kullanıcı davranışı ve yolculuk analizi</li>
                    <li>Hata raporlama ve performans ölçümü</li>
                    <li>Site iyileştirmeleri için veri toplama</li>
                  </ul>
                  <p className="mt-3 text-sm italic text-gray-600">
                    * Bu çerezler anonim veri toplar ve bireysel kullanıcıları tanımlamaz.
                  </p>
                </div>

                <div className="border-l-4 border-purple-500 pl-6">
                  <h3 className="text-xl font-semibold text-gray-800 mb-3">
                    2.3. Fonksiyonel Çerezler (Functionality Cookies)
                  </h3>
                  <p className="mb-3">
                    Bu çerezler, web sitesinin gelişmiş işlevler ve kişiselleştirme sunmasını sağlar. Sizin veya web sitesini kullanan diğer kullanıcıların yaptığı seçimlere dayalı olarak ayarlanabilirler.
                  </p>
                  <p className="text-sm font-semibold text-gray-800">Kullanım Amaçları:</p>
                  <ul className="list-disc list-inside space-y-1 ml-4 text-sm">
                    <li>Dil tercihi saklama</li>
                    <li>Bölge ve zaman dilimi ayarları</li>
                    <li>Önceki form girişlerini hatırlama</li>
                    <li>Kullanıcı arayüzü tercihlerini saklama</li>
                  </ul>
                </div>

                <div className="border-l-4 border-orange-500 pl-6">
                  <h3 className="text-xl font-semibold text-gray-800 mb-3">
                    2.4. Pazarlama/Reklam Çerezleri (Advertising Cookies)
                  </h3>
                  <p className="mb-3">
                    Bu çerezler, web sitemizdeki ziyaretinizi izlemek ve size kişiselleştirilmiş reklamlar sunmak için kullanılır. Ayrıca reklam kampanyalarının etkinliğini ölçmemize yardımcı olur.
                  </p>
                  <p className="text-sm font-semibold text-gray-800">Kullanım Amaçları:</p>
                  <ul className="list-disc list-inside space-y-1 ml-4 text-sm">
                    <li><strong>Google Ads:</strong> Dönüşüm takibi ve remarketing kampanyaları</li>
                    <li><strong>Google Display Network:</strong> Banner reklamlar ve remarketing</li>
                    <li><strong>YouTube Ads:</strong> Video reklam kampanyaları</li>
                    <li>Kişiselleştirilmiş reklam gösterimi</li>
                    <li>Kampanya performans ölçümü ve ROI analizi</li>
                    <li>Remarketing ve retargeting faaliyetleri</li>
                  </ul>
                  <p className="mt-3 text-sm italic text-gray-600">
                    * Bu çerezleri reddederseniz, genel reklamlar görmeye devam edersiniz ancak sizin ilgi alanlarınıza göre kişiselleştirilmemiş olurlar.
                  </p>
                </div>
              </div>
            </div>
          </section>

          <section className="mb-10">
            <h2 className="text-2xl font-bold text-gray-900 mb-4">
              3. Detaylı Çerez Listesi
            </h2>
            <div className="text-gray-700 leading-relaxed">
              <p className="mb-4">
                Web sitemizde kullanılan çerezlerin detaylı listesi aşağıda verilmiştir:
              </p>
              
              <div className="overflow-x-auto">
                <table className="min-w-full border border-gray-300 text-sm">
                  <thead className="bg-gray-100">
                    <tr>
                      <th className="border border-gray-300 px-4 py-3 text-left font-semibold">Çerez Adı</th>
                      <th className="border border-gray-300 px-4 py-3 text-left font-semibold">Sağlayıcı</th>
                      <th className="border border-gray-300 px-4 py-3 text-left font-semibold">Amaç</th>
                      <th className="border border-gray-300 px-4 py-3 text-left font-semibold">Tür</th>
                      <th className="border border-gray-300 px-4 py-3 text-left font-semibold">Süre</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td className="border border-gray-300 px-4 py-2 font-mono text-xs">_ga</td>
                      <td className="border border-gray-300 px-4 py-2">Google Analytics</td>
                      <td className="border border-gray-300 px-4 py-2">Kullanıcıları ayırt etmek için kullanılır</td>
                      <td className="border border-gray-300 px-4 py-2">Performans</td>
                      <td className="border border-gray-300 px-4 py-2">2 yıl</td>
                    </tr>
                    <tr className="bg-gray-50">
                      <td className="border border-gray-300 px-4 py-2 font-mono text-xs">_gid</td>
                      <td className="border border-gray-300 px-4 py-2">Google Analytics</td>
                      <td className="border border-gray-300 px-4 py-2">Kullanıcıları ayırt etmek için kullanılır</td>
                      <td className="border border-gray-300 px-4 py-2">Performans</td>
                      <td className="border border-gray-300 px-4 py-2">24 saat</td>
                    </tr>
                    <tr>
                      <td className="border border-gray-300 px-4 py-2 font-mono text-xs">_gat</td>
                      <td className="border border-gray-300 px-4 py-2">Google Analytics</td>
                      <td className="border border-gray-300 px-4 py-2">İstek oranını sınırlamak için kullanılır</td>
                      <td className="border border-gray-300 px-4 py-2">Performans</td>
                      <td className="border border-gray-300 px-4 py-2">1 dakika</td>
                    </tr>
                    <tr className="bg-gray-50">
                      <td className="border border-gray-300 px-4 py-2 font-mono text-xs">_gcl_au</td>
                      <td className="border border-gray-300 px-4 py-2">Google Ads</td>
                      <td className="border border-gray-300 px-4 py-2">Dönüşüm takibi ve reklam performansı</td>
                      <td className="border border-gray-300 px-4 py-2">Pazarlama</td>
                      <td className="border border-gray-300 px-4 py-2">90 gün</td>
                    </tr>
                    <tr>
                      <td className="border border-gray-300 px-4 py-2 font-mono text-xs">_gcl_dc</td>
                      <td className="border border-gray-300 px-4 py-2">Google Ads</td>
                      <td className="border border-gray-300 px-4 py-2">Display kampanyaları için tıklama bilgisi</td>
                      <td className="border border-gray-300 px-4 py-2">Pazarlama</td>
                      <td className="border border-gray-300 px-4 py-2">90 gün</td>
                    </tr>
                    <tr className="bg-gray-50">
                      <td className="border border-gray-300 px-4 py-2 font-mono text-xs">_gcl_aw</td>
                      <td className="border border-gray-300 px-4 py-2">Google Ads</td>
                      <td className="border border-gray-300 px-4 py-2">Google Ads dönüşüm takibi</td>
                      <td className="border border-gray-300 px-4 py-2">Pazarlama</td>
                      <td className="border border-gray-300 px-4 py-2">90 gün</td>
                    </tr>
                    <tr>
                      <td className="border border-gray-300 px-4 py-2 font-mono text-xs">consent_preferences</td>
                      <td className="border border-gray-300 px-4 py-2">Reklam Uzmanı</td>
                      <td className="border border-gray-300 px-4 py-2">Çerez onay tercihlerini saklar</td>
                      <td className="border border-gray-300 px-4 py-2">Zorunlu</td>
                      <td className="border border-gray-300 px-4 py-2">1 yıl</td>
                    </tr>
                    <tr className="bg-gray-50">
                      <td className="border border-gray-300 px-4 py-2 font-mono text-xs">__Secure-*</td>
                      <td className="border border-gray-300 px-4 py-2">Google</td>
                      <td className="border border-gray-300 px-4 py-2">Güvenlik ve bot koruması</td>
                      <td className="border border-gray-300 px-4 py-2">Zorunlu</td>
                      <td className="border border-gray-300 px-4 py-2">Değişken</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </section>

          <section className="mb-10">
            <h2 className="text-2xl font-bold text-gray-900 mb-4">
              4. Google Consent Mode v2 Uyumu
            </h2>
            <div className="text-gray-700 leading-relaxed">
              <p className="mb-4">
                Web sitemiz, Google'ın 2024 yılında zorunlu kıldığı <strong>Google Consent Mode v2</strong> standartlarına tam uyumludur. Bu, kullanıcı çerez tercihlerinin Google Analytics ve Google Ads'e doğru bir şekilde iletilmesini sağlar.
              </p>

              <h3 className="text-xl font-semibold text-gray-800 mt-6 mb-3">
                Consent Mode Parametreleri:
              </h3>
              <ul className="list-disc list-inside space-y-2 ml-4">
                <li>
                  <strong>ad_storage:</strong> Reklam çerezlerinin saklanması için onay durumu
                </li>
                <li>
                  <strong>analytics_storage:</strong> Analiz çerezlerinin saklanması için onay durumu
                </li>
                <li>
                  <strong>ad_user_data:</strong> Kullanıcı verilerinin Google'a gönderilmesi için onay
                </li>
                <li>
                  <strong>ad_personalization:</strong> Kişiselleştirilmiş reklamlar için onay
                </li>
              </ul>

              <p className="mt-4">
                Çerez banner'ımızda yaptığınız tercihler, bu parametreleri otomatik olarak günceller ve Google hizmetlerine bildirir.
              </p>
            </div>
          </section>

          <section className="mb-10">
            <h2 className="text-2xl font-bold text-gray-900 mb-4">
              5. Çerez Tercihlerinizi Nasıl Yönetirsiniz?
            </h2>
            <div className="text-gray-700 leading-relaxed">
              
              <h3 className="text-xl font-semibold text-gray-800 mt-6 mb-3">
                5.1. Çerez Banner'ı Kullanarak
              </h3>
              <p className="mb-4">
                Web sitemizi ilk ziyaret ettiğinizde, sayfanın alt kısmında bir çerez banner'ı görüntülenir. Bu banner'da şu seçenekler bulunur:
              </p>
              <ul className="list-disc list-inside space-y-2 ml-4">
                <li><strong>Tümünü Kabul Et:</strong> Tüm çerez kategorilerini kabul eder</li>
                <li><strong>Tümünü Reddet:</strong> Zorunlu çerezler hariç tüm çerezleri reddeder</li>
                <li><strong>Tercihleri Yönet:</strong> Her çerez kategorisini ayrı ayrı kabul veya reddedebilirsiniz</li>
              </ul>

              <h3 className="text-xl font-semibold text-gray-800 mt-6 mb-3">
                5.2. Tarayıcı Ayarları
              </h3>
              <p className="mb-4">
                Çoğu web tarayıcısı, çerezleri otomatik olarak kabul eder ancak tarayıcı ayarlarından çerezleri engelleyebilir veya silebilirsiniz:
              </p>
              <ul className="list-disc list-inside space-y-2 ml-4">
                <li><strong>Google Chrome:</strong> Ayarlar → Gizlilik ve güvenlik → Çerezler ve diğer site verileri</li>
                <li><strong>Mozilla Firefox:</strong> Seçenekler → Gizlilik ve Güvenlik → Çerezler ve Site Verileri</li>
                <li><strong>Safari:</strong> Tercihler → Gizlilik → Çerezleri ve web sitesi verilerini yönet</li>
                <li><strong>Microsoft Edge:</strong> Ayarlar → Çerezler ve site izinleri → Çerezleri yönet ve sil</li>
              </ul>

              <div className="bg-yellow-50 border-l-4 border-yellow-400 p-4 mt-6">
                <p className="text-sm text-gray-800">
                  <strong>Önemli Not:</strong> Çerezleri tamamen devre dışı bırakırsanız, web sitesinin bazı işlevleri düzgün çalışmayabilir.
                </p>
              </div>

              <h3 className="text-xl font-semibold text-gray-800 mt-6 mb-3">
                5.3. Üçüncü Taraf Çerez Yönetimi
              </h3>
              <p className="mb-4">
                Google ve Facebook/Meta gibi üçüncü taraf platformlardan gelen çerezleri yönetmek için:
              </p>
              <ul className="list-disc list-inside space-y-2 ml-4">
                <li>
                  <strong>Google Ads Settings:</strong>{" "}
                  <a href="https://adssettings.google.com/" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:underline">
                    https://adssettings.google.com/
                  </a>
                </li>
                <li>
                  <strong>Facebook Ad Preferences:</strong>{" "}
                  <a href="https://www.facebook.com/ads/preferences/" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:underline">
                    https://www.facebook.com/ads/preferences/
                  </a>
                </li>
                <li>
                  <strong>Google Analytics Opt-out:</strong>{" "}
                  <a href="https://tools.google.com/dlpage/gaoptout" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:underline">
                    https://tools.google.com/dlpage/gaoptout
                  </a>
                </li>
              </ul>
            </div>
          </section>

          <section className="mb-10">
            <h2 className="text-2xl font-bold text-gray-900 mb-4">
              6. Üçüncü Taraf Çerez Politikaları
            </h2>
            <div className="text-gray-700 leading-relaxed">
              <p className="mb-4">
                Web sitemizde kullanılan üçüncü taraf hizmet sağlayıcılarının gizlilik ve çerez politikalarını aşağıdaki linklerden inceleyebilirsiniz:
              </p>
              <ul className="list-disc list-inside space-y-2 ml-4">
                <li>
                  <strong>Google Privacy Policy:</strong>{" "}
                  <a href="https://policies.google.com/privacy" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:underline">
                    https://policies.google.com/privacy
                  </a>
                </li>
                <li>
                  <strong>Google Ads Data Usage:</strong>{" "}
                  <a href="https://support.google.com/google-ads/answer/2407785" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:underline">
                    https://support.google.com/google-ads/answer/2407785
                  </a>
                </li>
                <li>
                  <strong>Meta (Facebook) Data Policy:</strong>{" "}
                  <a href="https://www.facebook.com/privacy/policy/" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:underline">
                    https://www.facebook.com/privacy/policy/
                  </a>
                </li>
                <li>
                  <strong>Meta Business Tools:</strong>{" "}
                  <a href="https://www.facebook.com/business/tools/meta-pixel" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:underline">
                    https://www.facebook.com/business/tools/meta-pixel
                  </a>
                </li>
              </ul>
            </div>
          </section>

          <section className="mb-10">
            <h2 className="text-2xl font-bold text-gray-900 mb-4">
              7. Çerez Reddetmenin Sonuçları
            </h2>
            <div className="text-gray-700 leading-relaxed">
              <p className="mb-4">
                Çerezleri reddederseniz:
              </p>
              <ul className="list-disc list-inside space-y-2 ml-4">
                <li>✅ Web sitesinin temel işlevselliği çalışmaya devam eder</li>
                <li>✅ Güvenlik özellikleri aktif kalır</li>
                <li>❌ Kullanıcı tercihleriniz hatırlanmayabilir (dil, bölge vb.)</li>
                <li>❌ Site performansını optimize edemeyiz</li>
                <li>❌ Size kişiselleştirilmiş reklamlar sunulamaz (genel reklamlar görürsünüz)</li>
                <li>❌ Kampanya etkinliğini tam olarak ölçemeyiz</li>
                <li>❌ Bazı gelişmiş özellikler kullanılamayabilir</li>
              </ul>
            </div>
          </section>

          <section className="mb-10">
            <h2 className="text-2xl font-bold text-gray-900 mb-4">
              8. Çerez Politikası Güncellemeleri
            </h2>
            <div className="text-gray-700 leading-relaxed">
              <p>
                Bu Çerez Politikası, yasal düzenlemelerdeki değişiklikler, yeni teknolojiler veya hizmetlerimizdeki güncellemeler doğrultusunda zaman zaman güncellenebilir. Önemli değişiklikler yapıldığında, web sitemiz üzerinden bilgilendirme yapılacaktır.
              </p>
              <p className="mt-3">
                En güncel çerez politikamızı görmek için düzenli olarak bu sayfayı ziyaret etmenizi öneririz.
              </p>
            </div>
          </section>

          <section className="mb-10">
            <h2 className="text-2xl font-bold text-gray-900 mb-4">
              9. İletişim
            </h2>
            <div className="text-gray-700 leading-relaxed">
              <p className="mb-4">
                Çerez politikamız veya veri işleme uygulamalarımız hakkında sorularınız varsa, bizimle iletişime geçebilirsiniz:
              </p>
              <ul className="list-disc list-inside space-y-2 ml-4">
                <li><strong>E-posta:</strong> info@reklam-uzmani.com.tr</li>
                <li><strong>Telefon:</strong> +90 535 838 62 97</li>
                <li><strong>Adres:</strong> Adnan Kahveci, Yavuz Sultan Selim Blv. uyum çarşı içi kat 1 iç kapı no 72, 34528 Beylikdüzü/İstanbul</li>
              </ul>
            </div>
          </section>

        </div>

        {/* İletişim CTA */}
        <div className="mt-12 p-6 bg-gradient-to-r from-[#012f23] to-[#059669] rounded-lg text-white">
          <h3 className="text-xl font-bold mb-3">
            Çerez Tercihlerinizi Güncelleyin
          </h3>
          <p className="mb-4 text-gray-100">
            Çerez tercihleri ve gizliliğiniz hakkında sorularınız için bizimle iletişime geçin.
          </p>
          <div className="flex flex-wrap gap-4">
            <a
              href="mailto:info@reklam-uzmani.com.tr"
              className="inline-flex items-center gap-2 px-6 py-3 bg-white text-[#012f23] rounded-lg font-medium hover:bg-gray-100 transition-colors"
            >
              <Mail className="w-5 h-5" />
              info@reklam-uzmani.com.tr
            </a>
            <a
              href="tel:05326369115"
              className="inline-flex items-center gap-2 px-6 py-3 bg-white text-[#012f23] rounded-lg font-medium hover:bg-gray-100 transition-colors"
            >
              <Phone className="w-5 h-5" />
              0532 636 91 15
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Cookies;
